import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      library: {
        ...store.getState().i18n.translations.en.library,
        main: {
          CONFIRM: 'Confirmation',
          NOTI_CONFIRM:
            'Are you sure you want to save these filter settings as default?',
          FROM: 'From',
          TO: 'To',
          TOAST_MESS_ON_ALERT:
            '%{name} alerts are turned on for selected portfolios.',
          TOAST_MESS_OFF_ALERT:
            '%{name} alerts are turned off for selected portfolios.',
          TOAST_ERROR: 'Something went wrong, please try again!',
          LEAST2: 'Insert at least 2 letters',
          SAVED_PORTFOLIO: 'Saved Portfolios',
          FILTERED_COMPANIES: 'Filtered Companies',
          DOWNLOADED_FILES: 'Downloaded Files',
          FOLLOWING_LIST: 'Following List',
          TOTAL_PORTFOLIO: 'Total Portfolio',
          TOTAL_COMPANIES: 'Total Companies',
          BACK_PORTFOLIO: 'Back to Saved Portfolios',
          BACK_SAVED_PORTFOLIO: 'Back to Portfolio Management',
          ITEM_SELECT: '%{count} items selected',
          ITEM_SINGLE_SELECT: '%{count} item selected',
          SELECT_ALL: 'Select all %{count} items',
          UNSELECT_ALL: 'Unselect all items',
          OPEN_TAB: 'Open link in new tab',
          NODATA_SAVE_PORTFOLIO: 'No portfolios have been saved',
          FROM_DATE: 'From: dd/mm/yyy',
          TO_DATE: 'To: dd/mm/yyy',
          DELETE: 'Delete',
          REMOVE: 'Remove',
          ON_ALERT: 'On',
          OFF_ALERT: 'Off',
          BACK_TO_COMPANY_FILTER: 'Back to Filtered Companies',
          BACK_TO_PAGE: 'Back to previous page',
          NOTI_NO_COMPANY_SEARCH: 'No items match your search.',
          CREATE: 'Create',
          ADD_CART: 'Add to cart FiinGate Factsheet',
          BUY_FIIN: 'Check out FiinGate Factsheet',
          MOVE: 'Move to portfolio',
          COPY: 'Copy to portfolio',
          REMOVE_COMPANY: 'Remove this company from selected portfolio',
          TURN_ON_ALERT: 'Turn on this companies Alert',
          TURN_OF_ALERT: 'Turn off this companies Alert',
          NOT_SET: 'Not set',
          VALIDATE_PORTFOLIO: 'The number of portfolios is no more than 300.',
          VALIDATE_COMPANY:
            "The number of portfolio's companies is no more than 500.",
          REMOVE_FROM_PORT: 'Remove from portfolio',
          NODATA_ADD_COMPANY:
            'No items match your search </br> or this company has already existed in this list or this portfolio',
          NODATA_SEARCH_COMPANY: 'No items match your search',
          DOWNLOAD: 'Download',
          NOTI_DEAILS: 'Details',
        },
        savePortfolio: {
          COMPANY: 'Company',
          PORTFOLIO: 'Portfolio',
          savePortfolio: 'Portfolio',
          SEARCH_PORTFOLIO: 'Search portfolio name',
          SEARCH_COMPANIES: 'Search company name or tax code',
          NUMBER_OF_COMPANIES: 'Number of Companies',
          ALERT_PROFILE: 'Alert Profile',
          DATE_CREATED: 'Date Created',
          DATE_MODIFIED: 'Date Modified',
          TOTAL_COMPANIES: 'Total Companies',
          TOTAL_PORTFOLIO: 'Total Portfolios',
          CREATE_PORTFOLIO: 'Create Portfolio',
          EXPORT: 'Export',
          RENAME: 'Rename',
          NOT_SET: 'Not Set',
          MESSAGE_ALERT_PORTFOLIO:
            'Select an alert profile or create a new profile',
          CREATE_ALERT_PROFILE: 'Create Alert Profile',
          CREATE_NEW_PORTFOLIO: 'Create new portfolio',
          ENTER_NAME_PORTFOLIO: 'Enter portfolio name',
          TEXT_CREATE_PORTFOLIO:
            'Are you sure you want to create this portfolio?',
          TEXT_DELETE_PORTFOLIO:
            'Are you sure you want to delete "<b>%{name}</b>"?',
          DELETE_PORTFOLIO: 'Delete Portfolio',
          TEXT_DELETE_PORTFOLIOS:
            'Are you sure you want to delete %{count} portfolios?',
          TEXT_DELETE_PORTFOLIO_SINGLE:
            'Are you sure you want to delete %{count} portfolio?',
          TEXT_DELETE_ALL_PORTFOLIOS:
            'Are you sure you want to delete all portfolios?',
          TEXT_REMOVE_COMPANY:
            'Are you sure you want to remove <b>%{companyName}</b> from <b>%{count}</b> portfolios?',
          UPGRADE_ACCOUNT: 'Upgrade your account to use this feature',
          DUPLICATE: 'Duplicate',
        },
        detailsPortfolios: {
          TAX_CODE: 'Tax Code',
          STATUS: 'Status',
          ALERT: 'Alert',
          DATE_DOWNLOADED: 'Date Downloaded',
          NUMBER_OF_COMPANIES: 'Number Of Companies',
          ALERT_PROFILE: 'Alert Profile',
          DATE_CREATED: 'Date Created',
          DATE_MODIFIED: 'Date Modified',
          ADD_COMPANY: 'Add Company',
          SEARCH_COMPANY_TEXT_CODE: 'Search company name or tax code',
          VIEW_PORTFOLIO_INSIGHT: 'View portfolio insights',
          TEXT_INF_ICON:
            "Last time this Company's FiinGate Factsheet was downloaded",
          COMPANIES_LIST: 'Company List (%{count})',
          TEXT_DISCARD_TOP: 'Are you sure you want to discard this list?',
          TEXT_DISCARD_BOT:
            'If you click <b>Discard</b>, your recent company list will be removed.',
          DISCARD_CHANGE: 'Discard Change',
          DISCARD: 'Discard',
          TEXT_ADD_COMPANY:
            'Are you sure you want to add <b>%{count}</b> companies to <b>"%{name}"</b>?',
          TEXT_ADD_COMPANY2:
            'Are you sure you want to add <b>%{count}</b> company to <b>"%{name}"</b>?',
          CONFIRMATION: 'Confirmation',
          TEXT_POPUP_ADD_COMPANY:
            'Add companies to this portfolio using the search box or by uploading a file',
          NO_CHOOSE_FILE: 'No files selected',
          CHOOSE_FILE: 'Choose file',
          UP_LOAD: 'Upload',
          DOWNLOAD_TEMPLATE: 'Download template',
          TEXT_DELETE_SINGLE_COMPANY:
            'Are you sure you want to remove <b>%{companyName}</b> from <b>%{portfolioName}</b>?',
          TEXT_DELETE_MULTI_COMPANY:
            'Are you sure you want to remove <b>%{count}</b> companies from <b>%{portfolioName}</b>?',
          TEXT_DELETE_MULTI_COMPANY2:
            'Are you sure you want to remove <b>%{count}</b> company from <b>%{portfolioName}</b>?',
          VALIDATE_TAX_CODE_EXISTED:
            '!Tax Code %{taxCode} company has already existed in this portfolio',
          VALIDATE_TAX_CODE: '! Tax code %{taxCode} is not available',
          VALIDATE_TAX_CODE_DUPLICATE:
            '! Tax code %{taxCode} company has already existed in this portfolio',
          VALIDATE_FORMAT_FILE: '! Invalid file format',
          TEXT_NOTI_ADD_COMPANY:
            'Add companies to this portfolio using the search box or by uploading a file',
          TEXT_COPY_TO_PORTFOLIO: 'Copy to portfolio',
          TEXT_MOVE_TO_PORTFOLIO: 'Move to portfolio',
          ADD_TO_PORT: 'Add to portfolio',
        },
        filterCompanies: {
          FILTER: 'Filter',
          COMPANIES: '%{count} Companies',
          COMPANY: '%{count} Company',
          FILTERED_PORTFOLIO: 'Filtered portfolio',
          CLEAR_ALL: 'Clear All',
          CREDIT_SCORE: 'Corporate Risk Score',
          PERFORMANCE_SCORE: 'Performance Score',
          TEXT_FILTER_DISPLAY:
            '(Include portfolio: %{portfolio} selected | Exclude: %{exclude} selected | Risk Levels: %{riskLevels} selected)',
          NO_DATA: 'No companies match your filters.',
          CURRENT_CREDIT: 'Current Corporate Risk Score (%{range})',
          PREV_CREDIT: 'Previous Corporate Risk Score (%{range})',
          CURRENT_PER: 'Current Performance Score (%{range})',
          PREV_PER: 'Previous Performance Score (%{range})',
        },
        filterSetting: {
          YEAR_ACTIVE: 'Years in Operation',
          YEAR_ACTIVE_HOLDER: 'Years in Operation',
          CURENCY: 'Currency',
          YEAR: 'Year',
          QUARTER: 'Quarter',
          MONTH: 'Month',
          ALL_ITEMS_SELECT: 'All items selected',
          FILTER_SETTING: 'Filter Settings',
          SUMMARY: 'Summary',
          CANCEL: 'Cancel',
          APPLY: 'Apply',
          SET_DEFAULT: 'Set As Default',
          SCORE_LEVEL: 'Score Level',
          PROVINCE: 'Province',
          PROVINCE_HOLDER: 'Province',
          INDUSTRY: 'Industry',
          INDUSTRY_VSIC: 'Industry (VSIC)',
          BUSINESS_SIZE: 'Business Size',
          YEARS_OF_OPERATION: 'Years in Operation',
          DETAIL: 'Detail',
          TEXT_DETAIL:
            ' (Select items to identify remarkable companies in all your portfolios)',
          RESET: 'Reset',
          EXCLUDE: 'Exclude',
          PERIOD_TYPE: 'Period Type',
          CURRENT_SCORE: 'Current Score',
          PREVIOUS_SCORE: 'Previous Score',
          FIINGATE_LEVEL: 'FiinGate Levels',
          VERY_LOW_RISK: 'Very Low Risk',
          LOW_RISK: 'Low Risk',
          MODERATE_RISK: 'Moderate Risk',
          SIGNIFICANT_RISK: 'Significant Risk',
          AGGRESSIVE_RISK: 'Aggressive Risk',
          UNDETERMINED: 'Undetermined',
          HIGH_GROWTH_POTENTIAL: 'High Growth Potential',
          DECENT_GROWTH_POTENTIAL: 'Decent Growth Potential',
          MODEST_GROWTH_POTENTIAL: 'Modest Growth Potential',
          INSIGNIFICANT_GROWTH_POTENTIAL: 'Insignificant Growth Potential',
          CUSTOM_RANGES: 'Custom Ranges',
          SIZE_SELECT: 'Select business size',
          AND: 'And',
          OR: 'Or',
          SCORE_LEVEL_TITLE: 'Score Levels',
        },
        downloadedFiles: {
          NO_DATA_DOWNLOAD: 'No files have been purchased',
          TOTAL_AVAILABLE_FILES: 'Total Available Files',
          SEARCH_FILENAME: 'Search file name',
          CATEGORY: 'Category',
          DELIVERY_DATE: 'Delivery Date',
          EXPIRY_DATE: 'Expiry Date',
          FILE_FORMAT: 'File Format',
          ALL: 'All',
          SCREENING_FILE: 'Screening File',
          BUSINESS_CREDIT_REPORT: 'Business Credit Report',
          INTERNATIONAL_COMPANY_REPORT: 'International Company Report',
          FIINGATE_FACTSHEET: 'FiinGate Factsheet',
          NO_DATA: 'You have not had any files.',
        },
        followingList: { NO_COMPANY_TEXT: 'No companies have been added' },
        selectedFilter: {
          ALL_PORT: 'All portfolios',
          ALL_PORT_SELECT_FILTER: 'Portfolios: All items selected',
          PORTFOLIO: 'Portfolio: %{count} selected',
          EXCLUDE: 'Exclude: %{count} selected',
          CREDIT_SCORE_CURRENT: 'Current credit risk score',
          CREDIT_SCORE_PREV: 'Previous credit risk score',
          PERFORMANCE_CURRENT: 'Current performance score',
          PERFORMANCE_PREV: 'Previous performance score',
          PROVINCE: 'Province: %{count} selected',
          INDUSTRY: 'Industry (VSIC): %{count} selected',
          BUSINESS_SIZE: 'Business Size (by Net Revenue): %{count} selected',
          YEARS_OF_OPERATION: 'Years in Operation: %{count} selected',
          COMPANY: 'Company',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      library: {
        ...store.getState().i18n.translations.vi.library,
        main: {
          CONFIRM: 'Đặt làm mặc định',
          NOTI_CONFIRM: 'Bạn có muốn đặt bộ lọc này làm mặc định?',
          FROM: 'Từ',
          TO: 'Đến',
          TOAST_MESS_ON_ALERT:
            'Cảnh báo của %{name} đã được bật trong các danh mục được chọn.',
          TOAST_MESS_OFF_ALERT:
            'Cảnh báo của %{name} đã được tắt trong các danh mục được chọn.',
          TOAST_ERROR: 'Có lỗi xảy ra, xin vui lòng thử lại!',
          LEAST2: 'Nhập ít nhất 2 ký tự',
          SAVED_PORTFOLIO: 'Danh Mục Đã Lưu',
          FILTERED_COMPANIES: 'Lọc Công Ty Từ Danh Mục',
          DOWNLOADED_FILES: 'Tài Liệu Tải Xuống',
          FOLLOWING_LIST: 'Danh Sách Theo Dõi',
          TOTAL_PORTFOLIO: 'Tổng Số Danh Mục',
          TOTAL_COMPANIES: 'Tổng Số Công Ty',
          BACK_PORTFOLIO: 'Quay lại màn Danh mục đã lưu',
          BACK_SAVED_PORTFOLIO: 'Quay lại màn danh mục',
          ITEM_SELECT: 'Đã chọn %{count}',
          ITEM_SINGLE_SELECT: 'Đã chọn %{count}',
          SELECT_ALL: 'Chọn tất cả %{count} bản ghi',
          UNSELECT_ALL: 'Bỏ chọn tất cả',
          OPEN_TAB: 'Mở đường liên kết trong tab mới',
          NODATA_SAVE_PORTFOLIO: 'Chưa có danh mục được tạo.',
          FROM_DATE: 'Từ: dd/mm/yyy',
          TO_DATE: 'Đến: dd/mm/yyy',
          DELETE: 'Xóa',
          REMOVE: 'Loại Bỏ',
          ON_ALERT: 'Bật',
          OFF_ALERT: 'Tắt',
          BACK_TO_COMPANY_FILTER: 'Quay lại màn Lọc Công Ty Từ Danh Mục',
          BACK_TO_PAGE: 'Quay lại trang trước',
          NOTI_NO_COMPANY_SEARCH:
            'Không có công ty nào thỏa mãn điều kiện tìm kiếm.',
          CREATE: 'Tạo',
          ADD_CART: 'Thêm vào giỏ FiinGate Factsheet',
          BUY_FIIN: 'Mua ngay FiinGate Factsheet',
          MOVE: 'Chuyển tới danh mục',
          COPY: 'Sao chép tới danh mục',
          REMOVE_COMPANY: 'Xóa công ty khỏi danh mục',
          TURN_ON_ALERT:
            'Bật cảnh báo cho cho công ty được chọn trong các danh mục',
          TURN_OF_ALERT:
            'Tắt cảnh báo cho công ty được chọn trong các danh mục',
          NOT_SET: 'Không thiết lập',
          VALIDATE_PORTFOLIO: 'Số lượng danh mục tối đa là 300.',
          VALIDATE_COMPANY: 'Số lượng công ty trong danh mục tối đa là 500.',
          REMOVE_FROM_PORT: 'Loại khỏi danh mục',
          NODATA_ADD_COMPANY:
            'Không có kết quả phù hợp </br> hoặc công ty này hiện đã có trong danh mục hoặc danh sách này',
          NODATA_SEARCH_COMPANY: 'Không có kết quả phù hợp',
          DOWNLOAD: 'Tải xuống',
          NOTI_DEAILS: 'Thông tin chi tiết',
        },
        savePortfolio: {
          COMPANY: 'Công ty',
          savePortfolio: 'Danh mục',
          SEARCH_PORTFOLIO: 'Tìm kiếm theo tên danh mục',
          SEARCH_COMPANIES: 'Tìm kiếm theo tên công ty hoặc mã số thuế',
          NUMBER_OF_COMPANIES: 'Số Lượng Công Ty',
          ALERT_PROFILE: 'Quy Tắc Cảnh Báo',
          DATE_CREATED: 'Ngày Tạo',
          DATE_MODIFIED: 'Ngày cập nhật',
          TOTAL_COMPANIES: 'Tổng Số Công Ty',
          TOTAL_PORTFOLIO: 'Tổng Số Danh Mục',
          CREATE_PORTFOLIO: 'Tạo Danh Mục',
          EXPORT: 'Tải Xuống',
          RENAME: 'Đổi tên',
          PORTFOLIO: 'Danh Mục',
          NOT_SET: 'Không Thiết Lập',
          MESSAGE_ALERT_PORTFOLIO: 'Chọn bộ cảnh báo hoặc tạo bộ cảnh báo mới',
          CREATE_ALERT_PROFILE: 'Tạo mới bộ cảnh báo',
          TEXT_ALERT_SELECT: 'Chọn bộ cảnh báo hoặc tạo mới bộ cảnh báo',
          CREATE_NEW_PORTFOLIO: 'Tạo danh mục mới',
          ENTER_NAME_PORTFOLIO: 'Nhập tên danh mục',
          TEXT_CREATE_PORTFOLIO:
            'Bạn có chắc chắn muốn tạo danh mục đầu tư này không?',
          TEXT_DELETE_PORTFOLIO: 'Bạn muốn xóa danh mục <b>%{name}</b>?',
          DELETE_PORTFOLIO: 'Xóa danh mục',
          TEXT_DELETE_PORTFOLIOS: 'Bạn muốn xóa %{count} danh mục?',
          TEXT_DELETE_PORTFOLIO_SINGLE: 'Bạn muốn xóa %{count} danh mục?',
          TEXT_DELETE_ALL_PORTFOLIOS: 'Bạn muốn xóa tất cả danh mục?',
          TEXT_REMOVE_COMPANY:
            'Bạn muốn loại bỏ <b>%{companyName}</b> ra khỏi <b>%{count}</b> danh mục?',
          UPGRADE_ACCOUNT: 'Nâng cấp tài khoản để sử dụng tính năng này',
          DUPLICATE: 'Tạo bản sao',
        },
        detailsPortfolios: {
          TAX_CODE: 'Mã Số Thuế',
          STATUS: 'Trạng Thái',
          ALERT: 'Cảnh Báo',
          DATE_DOWNLOADED: 'Ngày Tải',
          NUMBER_OF_COMPANIES: 'Số Công Ty',
          ALERT_PROFILE: 'Quy Định Cảnh Báo',
          DATE_CREATED: 'Ngày Tạo',
          DATE_MODIFIED: 'Ngày Cập Nhật',
          ADD_COMPANY: 'Thêm Công Ty',
          SEARCH_COMPANY_TEXT_CODE: 'Tìm kiếm theo tên công ty hoặc mã số thuế',
          VIEW_PORTFOLIO_INSIGHT: 'Phân tích danh mục',
          TEXT_INF_ICON: 'Thời điểm tải FiinGate Factsheet gần nhất',
          COMPANIES_LIST: 'Danh sách công ty (%{count})',
          TEXT_DISCARD_TOP: 'Bạn muốn loại bỏ danh sách công ty này?',
          TEXT_DISCARD_BOT:
            'Nếu bạn chọn <b>Loại Bỏ</b>, danh sách công ty hiện tại sẽ bị xóa.',
          DISCARD_CHANGE: 'Hủy danh sách',
          DISCARD: 'Loại Bỏ',
          TEXT_ADD_COMPANY:
            'Bạn muốn thêm <b>%{count}</b> công ty vào <b>"%{name}"</b>?',
          TEXT_ADD_COMPANY2:
            'Bạn muốn thêm <b>%{count}</b> công ty vào <b>"%{name}"</b>?',
          CONFIRMATION: 'Xác nhận',
          TEXT_POPUP_ADD_COMPANY:
            'Thêm công ty vào danh mục bằng thanh tìm kiếm hoặc tải lên tệp excel danh sách công ty',
          NO_CHOOSE_FILE: 'Chưa có file tải lên',
          CHOOSE_FILE: 'Chọn file',
          UP_LOAD: 'Tải lên',
          DOWNLOAD_TEMPLATE: 'Tải mẫu',
          TEXT_DELETE_SINGLE_COMPANY:
            'Bạn muốn loại bỏ <b>%{companyName}</b> ra khỏi <b>%{portfolioName}</b>?',
          TEXT_DELETE_MULTI_COMPANY:
            'Bạn muốn loại bỏ <b>%{count}</b> công ty ra khỏi <b>%{portfolioName}</b>?',
          TEXT_DELETE_MULTI_COMPANY2:
            'Bạn muốn loại bỏ <b>%{count}</b> công ty ra khỏi <b>%{portfolioName}</b>?',
          VALIDATE_TAX_CODE_EXISTED:
            '!Mã số thuế %{taxCode} công ty đã tồn tại trong danh mục',
          VALIDATE_TAX_CODE: '! Mã số thuế %{taxCode} không tồn tại',
          VALIDATE_TAX_CODE_DUPLICATE:
            '! Mã số thuế %{taxCode} công ty đã tồn tại trong danh mục',
          VALIDATE_FORMAT_FILE: '! Định dạng tệp không hợp lệ',
          TEXT_NOTI_ADD_COMPANY:
            'Thêm công ty vào danh mục bằng thanh tìm kiếm hoặc tải lên tệp excel danh sách công ty',
          TEXT_COPY_TO_PORTFOLIO: 'Sao chép vào danh mục',
          TEXT_MOVE_TO_PORTFOLIO: 'Chuyển tới danh mục',
          ADD_TO_PORT: 'Thêm vào danh mục',
        },
        filterCompanies: {
          FILTER: 'Bộ lọc',
          COMPANIES: '%{count} Công ty',
          COMPANY: '%{count} Công ty',
          FILTERED_PORTFOLIO: 'Danh mục phân tích',
          CLEAR_ALL: 'Xóa tất cả',
          CREDIT_SCORE: 'Điểm Rủi Ro Doanh Nghiệp',
          PERFORMANCE_SCORE: 'Điểm Triển Vọng Tăng Trưởng',
          TEXT_FILTER_DISPLAY:
            '(Include portfolio: %{portfolio} selected | Exclude: %{exclude} selected | Risk Levels: %{riskLevels} selected)',
          NO_DATA: 'Không có công ty nào thỏa mãn bộ điều kiện.',
          CURRENT_CREDIT: 'Điểm rủi ro doanh nghiệp hiện tại (%{range})',
          PREV_CREDIT: 'Điểm rủi ro doanh nghiệp kỳ trước (%{range})',
          CURRENT_PER: 'Điểm triển vọng tăng trưởng hiện tại (%{range})',
          PREV_PER: 'Điểm triển vọng tăng trưởng kỳ trước (%{range})',
        },
        filterSetting: {
          YEAR_ACTIVE: 'Số Năm Hoạt Động',
          YEAR_ACTIVE_HOLDER: 'Số năm hoạt động',
          CURENCY: 'Tiền tệ',
          YEAR: 'Theo năm',
          QUARTER: 'Theo quý',
          MONTH: 'Theo tháng',
          ALL_ITEMS_SELECT: 'Đã chọn tất cả danh mục',
          FILTER_SETTING: 'Cài đặt bộ lọc',
          SUMMARY: 'Tóm tắt',
          CANCEL: 'Hủy',
          APPLY: 'Áp dụng',
          SET_DEFAULT: 'Cài làm mặc định',
          SCORE_LEVEL: 'Mức Điểm',
          PROVINCE: 'Tỉnh/ Thành Phố',
          PROVINCE_HOLDER: 'Tỉnh/ Thành phố',
          INDUSTRY: 'Ngành',
          INDUSTRY_VSIC: 'Ngành (VSIC)',
          BUSINESS_SIZE: 'Quy Mô',
          YEARS_OF_OPERATION: 'Số Năm Hoạt Động',
          DETAIL: 'Chi tiết',
          TEXT_DETAIL:
            ' (Chọn điều kiện lọc cho các tiêu chí dưới đây để tạo danh sách công ty từ các danh mục)',
          RESET: 'Đặt lại',
          EXCLUDE: 'Loại trừ',
          PERIOD_TYPE: 'Loại kỳ',
          CURRENT_SCORE: 'Mức điểm hiện tại',
          PREVIOUS_SCORE: 'Mức điểm kỳ trước',
          FIINGATE_LEVEL: 'Mức điểm theo FiinGate',
          VERY_LOW_RISK: 'Rủi ro rất thấp',
          LOW_RISK: 'Rủi ro thấp',
          MODERATE_RISK: 'Rủi ro trung bình',
          SIGNIFICANT_RISK: 'Rủi ro cao',
          AGGRESSIVE_RISK: 'Rủi ro rất cao',
          UNDETERMINED: 'Không xác định',
          HIGH_GROWTH_POTENTIAL: 'Tiềm năng tăng trưởng cao ',
          DECENT_GROWTH_POTENTIAL: 'Tiềm năng tăng trưởng trung bình',
          MODEST_GROWTH_POTENTIAL: 'Tiềm năng tăng trưởng thấp',
          INSIGNIFICANT_GROWTH_POTENTIAL: 'Tiềm năng tăng trưởng không đáng kể',
          CUSTOM_RANGES: 'Mức điểm tùy chỉnh',
          SIZE_SELECT: 'Chọn loại quy mô',
          AND: 'Và',
          OR: 'Hoặc',
          SCORE_LEVEL_TITLE: 'Mức Điểm',
        },
        downloadedFiles: {
          NO_DATA_DOWNLOAD: 'Hiện chưa có báo cáo hoặc dữ liệu được mua.',
          TOTAL_AVAILABLE_FILES: 'Tổng Số Tài Liệu',
          SEARCH_FILENAME: 'Tìm kiếm tên tập tin',
          CATEGORY: 'Phân Loại',
          DELIVERY_DATE: 'Ngày Phát Hành',
          EXPIRY_DATE: 'Ngày Hết Hạn',
          FILE_FORMAT: 'Định Dạng',
          ALL: 'Tất cả',
          SCREENING_FILE: 'Kết quả Sàng lọc tự động',
          BUSINESS_CREDIT_REPORT: 'Báo Cáo Tín Dụng Doanh Nghiệp',
          INTERNATIONAL_COMPANY_REPORT: 'Báo Cáo Công Ty Nước Ngoài',
          FIINGATE_FACTSHEET: 'FiinGate Factsheet',
          NO_DATA: 'Bạn chưa có tập tin nào.',
        },
        followingList: {
          NO_COMPANY_TEXT: 'Chưa có công ty trong danh sách theo dõi.',
        },
        selectedFilter: {
          ALL_PORT: 'Tất cả danh mục',
          ALL_PORT_SELECT_FILTER: 'Danh mục: Đã chọn tất cả',
          PORTFOLIO: 'Danh mục: Đã chọn %{count}',
          EXCLUDE: 'Loại trừ: %{count} công ty',
          CREDIT_SCORE_CURRENT: 'Điểm rủi ro tín dụng hiện tại',
          CREDIT_SCORE_PREV: 'Điểm rủi ro tín dụng kỳ trước',
          PERFORMANCE_CURRENT: 'Điểm triển vọng tăng trưởng hiện tại',
          PERFORMANCE_PREV: 'Điểm triển vọng tăng trưởng kỳ trước',
          PROVINCE: 'Tỉnh/Thành phố: Đã chọn %{count}',
          INDUSTRY: 'Ngành (VSIC): Đã chọn %{count}',
          BUSINESS_SIZE: 'Mức doanh thu thuần : Đã chọn %{count} ',
          YEARS_OF_OPERATION: 'Số năm hoạt động: Đã chọn %{count}',
          COMPANY: 'Công Ty',
        },
      },
    },
  }),
)
